module.exports = __webpack_public_path__ + "media/images/policy-bg-1024-248776b8056f2cf396083d5209d089f3.png";